'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _tslib = require('./_tslib-15827112.js');
var request = _interopDefault(require('axios'));

var IsValidResponse = function (response) { return response.status === 200 || (response.response && IsValidResponse(response.response)); };
var AuthApi = /** @class */ (function () {
    function AuthApi(AuthApiUrl) {
        this.getAuthHeader = function (token) { return ({ Authorization: "Bearer " + token }); };
        this.AuthApiUrl = AuthApiUrl;
    }
    AuthApi.prototype._getBaseHeaders = function () {
        var headers = {
            Accept: 'application/json; charset=UTF-8'
        };
        return headers;
    };
    AuthApi.prototype.Logout = function (token) {
        return this._post('_api/v1/Logout', {}, this.getAuthHeader(token));
    };
    AuthApi.prototype.LoginFacebook = function (body) {
        return this._post('_api/v1/Login/Facebook', body, {});
    };
    AuthApi.prototype.LoginGoogle = function (body) {
        return this._post('_api/v1/Login/Google', body, {});
    };
    AuthApi.prototype.GetUser = function (token) {
        return this._get('_api/v1/User', this.getAuthHeader(token));
    };
    AuthApi.prototype.GetUserLoyaltyCards = function (token, country) {
        return this._get('_api/v1/LoyaltyCards/' + country, this.getAuthHeader(token));
    };
    AuthApi.prototype.GetUserPromoCoupons = function (token, country) {
        return this._get('_api/v1/PromoCouponsUser/' + country, this.getAuthHeader(token));
    };
    AuthApi.prototype.InsertUserLoyaltyCard = function (body, header) {
        return this._post('_api/v1/LoyaltyCard', body, header);
    };
    AuthApi.prototype.InsertUserPromoCoupon = function (body, header) {
        return this._post('_api/v1/PromoCouponUser', body, header);
    };
    AuthApi.prototype.InsertUserPromoCouponWithLoyaltyCard = function (body, header) {
        return this._post('_api/v1/PromoCouponUser/WithLoyaltyCard', body, header);
    };
    AuthApi.prototype.DeleteUserLoyaltyCard = function (loyaltyCardId, header) {
        return this._delete('_api/v1/LoyaltyCard/' + loyaltyCardId, header);
    };
    AuthApi.prototype.DeleteUserPromoCoupon = function (id, header) {
        return this._delete('_api/v1/PromoCouponUser/' + id, header);
    };
    AuthApi.prototype.GetNewAccessToken = function (token) {
        return this._get('_api/v1/AccessToken/New', this.getAuthHeader(token));
    };
    AuthApi.prototype.GetReimbursementTypeByCountry = function (token, country) {
        return this._get('_api/v1/ReimbursementType/ByCountry/' + country, this.getAuthHeader(token));
    };
    AuthApi.prototype.GetReimbursementTypeById = function (token, id) {
        return this._get('_api/v1/ReimbursementType/' + id, this.getAuthHeader(token));
    };
    AuthApi.prototype.PostReimbursement = function (token, reimbursement) {
        return this._post('_api/v1/Reimbursement', reimbursement, this.getAuthHeader(token));
    };
    AuthApi.prototype.GetReimbursements = function (token, countryCode) {
        return this._get("_api/v1/Reimbursement/" + countryCode, this.getAuthHeader(token))
            .then(function (response) {
            var items = response.data || [];
            return items.map(function (item) {
                return {
                    amount: item.amount,
                    countryCode: item.countryCode,
                    created: new Date(item.created),
                    lastStatus: item.lastStatus,
                    reimbursementInfo: JSON.parse(item.reimbursementInfo || "{}"),
                };
            });
        });
    };
    AuthApi.prototype.InsertTickets = function (userId, token, promoCoupons, files, countryCode) {
        var headers = _tslib.__assign({ "Content-Type": "multipart/form-data" }, this.getAuthHeader(token));
        var body = new FormData();
        body.append("Country", countryCode);
        body.append("UserId", userId);
        promoCoupons.map(function (coupon) { return body.append("PromoCoupons", JSON.stringify(coupon)); });
        files.map(function (file) { return body.append("Files", file); });
        return this._post('_api/v1/Ticket', body, headers);
    };
    AuthApi.prototype.GetTicketDetail = function (token, id) {
        return this._get('_api/v1/Ticket/' + id, this.getAuthHeader(token));
    };
    AuthApi.prototype.GetHistory = function (token, countryCode) {
        var headers = _tslib.__assign({}, this.getAuthHeader(token));
        return this._get("_api/v1/Ticket/History/" + countryCode, headers);
    };
    AuthApi.prototype.GetUserBalance = function (token, countryCode) {
        var headers = _tslib.__assign({}, this.getAuthHeader(token));
        return this._get("_api/v1/Balance/" + countryCode, headers);
    };
    AuthApi.prototype._post = function (endpoint, data, headers) {
        var _this = this;
        var url = "" + this.AuthApiUrl + endpoint;
        return request.post(url, data, {
            headers: _tslib.__assign(_tslib.__assign({}, this._getBaseHeaders()), headers)
        }).catch(function (response) {
            _this._logError(url, response, data, headers);
            if (IsValidResponse(response))
                return response;
            throw response;
        });
    };
    AuthApi.prototype._delete = function (endpoint, headers) {
        var _this = this;
        var url = "" + this.AuthApiUrl + endpoint;
        return request.delete(url, {
            headers: _tslib.__assign(_tslib.__assign({}, this._getBaseHeaders()), headers)
        }).catch(function (response) {
            _this._logError(url, response, "", headers);
            if (IsValidResponse(response))
                return response;
            throw response;
        });
    };
    AuthApi.prototype._get = function (endpoint, headers) {
        var _this = this;
        var url = "" + this.AuthApiUrl + endpoint;
        return request.get(url, {
            headers: _tslib.__assign(_tslib.__assign({}, this._getBaseHeaders()), headers)
        }).catch(function (response) {
            _this._logError(url, response, "", headers);
            if (IsValidResponse(response))
                return response;
            throw response;
        });
    };
    AuthApi.prototype._logError = function (endpoint, response, data, headers) {
        var responseMsg = '';
        var message = '';
        try {
            responseMsg = typeof (response) === 'object' ? JSON.stringify(response) : response;
            var headersMsg = typeof (headers) === 'object' ? JSON.stringify(headers) : headers;
            var dataMsg = typeof (data) === 'object' ? JSON.stringify(data) : data;
            message = "Error AuthApi: " + response.message + ". \n UserAgent: " + navigator.userAgent + " \n Headers: " + headersMsg + " \n Data: " + dataMsg + " \n Cookies: " + document.cookie;
        }
        catch (e) {
            responseMsg = e.message;
            message = "Error AuthApi. Exception: " + e.name;
        }
        console.log(message, endpoint, 0, 0, responseMsg);
    };
    return AuthApi;
}());

exports.default = AuthApi;
//# sourceMappingURL=AuthApi.js.map
